@import '../../global/utility/responsive/responsive-mixins';
@import './gradients';
$sizes: 960, 765, 500, 400;

$white-gradient-left: linear-gradient(90deg, rgb(255 255 255 / 70%) 0%, rgb(216 216 216 / 0%) 90%);
$white-gradient-right: linear-gradient(-90deg, rgb(255 255 255 / 70%) 0%, rgb(216 216 216 / 0%) 90%);
$black-gradient-left: linear-gradient(90deg, rgb(0 0 0 / 70%) 0%, rgb(0 0 0 / 0%) 90%);
$black-gradient-right: linear-gradient(-90deg, rgb(0 0 0 / 70%) 0%, rgb(0 0 0 / 0%) 90%);

@include min-width($sizes, 400) {
  .quotation--with-image {
    .quotation__wrapper {
      padding-bottom: calc(100% * (9 / 16));
    }
  }
}

@include min-width($sizes, 500) {
  .quotation {
    &__image {
      margin-right: 24px;
    }

    &--with-image {
      .quotation__container {
        background-image: $white-gradient-left;
        background-position: center;
        background-size: 140% 140%;
        height: 100%;
        width: 100%;
      }

      .quotation__name,
      .quotation__info {
        font-size: $copy-font-size;
        line-height: $copy-line-height;
      }

      .quotation__text {
        text-indent: 0;

        &::before {
          margin-right: 100%;
          padding-right: 1px;
          position: absolute;
          right: 0;
        }
      }

      &.quotation--left.quotation--top {
        .quotation__container {
          background-position: right bottom;
          background-size: auto;
          left: 0;
          padding-right: 50%;
          top: 0;
        }
      }

      &.quotation--left.quotation--bottom {
        .quotation__container {
          background-position: right top;
          bottom: 0;
          justify-content: flex-end;
          left: 0;
          padding-right: 50%;
        }
      }

      &.quotation--right.quotation--top {
        .quotation__container {
          background-image: $white-gradient-right;
          background-position: left bottom;
          background-size: auto;
          padding-left: 50%;
          right: 0;
          top: 0;
        }
      }

      &.quotation--right.quotation--bottom {
        .quotation__container {
          background-image: $white-gradient-right;
          background-position: left top;
          background-size: auto;
          bottom: 0;
          justify-content: flex-end;
          padding-left: 50%;
          right: 0;
        }
      }

      &.quotation--white {
        .quotation__container {
          background-image: $black-gradient-left;
        }

        &.quotation--right {
          .quotation__container {
            background-image: $black-gradient-right;
          }
        }
      }
    }
  }
}

@include min-width($sizes, 765) {
  .quotation__text {
    font-size: 32px;
    line-height: 44px;
  }
}

@include min-width($sizes, 960) {
  .quotation--with-image {
    .quotation__name,
    .quotation__info {
      font-size: 22px;
      line-height: 32px;
    }

    .quotation__text {
      font-size: 44px;
      line-height: 52px;
    }
  }
}

:host {
  @include responsive($sizes);

  display: block;

  .quotation {
    margin: 0;

    &__text {
      font-family: var(--component-quotation-font-family, $font-family-sans-serif);
      font-style: var(--component-quotation-font-style, $body-font-style);
      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      margin: 0;
      overflow-wrap: break-word;
      position: relative;
      word-wrap: break-word;
    }

    &__meta {
      align-items: center;
      display: flex;
      flex: 0 0 auto;
      font-size: 16px;
      line-height: 24px;
      margin-top: 13px;
      position: relative;
    }

    &__name,
    &__info {
      margin: 0;
    }

    &__image {
      border-radius: 50%;
      overflow: hidden;
      flex: 0 0 65px;
      height: 65px;
      margin: 5px 0;
      margin-right: 20px;
      width: 65px;
    }

    &__name {
      font-weight: $font-weight-bold;
      margin: 0;

      + .quotation__info {
        /* stylelint-disable */
        margin-top: 0 !important;
        /* stylelint-enable */
      }
    }

    &__copyright {
      @extend %caption;

      color: $ui-grey-plus-1;
      margin-top: 10px;
    }
  }

  .quotation--with-image {
    position: relative;
    color: var(--skin-color-text, $ui-dark);

    .quotation__container {
      background-color: transparent;
      background-image: $white-gradient-img;
      background-position: center;
      background-size: 150% 150%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 17px;
      padding: 37px;
      position: absolute;
      width: 100%;
      z-index: 10;
    }

    .quotation__wrapper {
      height: 0;
      overflow: hidden;
      padding-bottom: calc(100% * (6 / 5));
      position: relative;
    }

    .quotation__background-image {
      display: block;
      height: 100%;
      left: 0;
      object-fit: cover;
      position: absolute;
      top: 0;
      width: 100%;
    }

    .quotation__text {
      text-indent: -9px;
    }

    .quotation__note {
      @extend %caption;

      color: $ui-grey-plus-1;
      margin-top: 10px;
    }

    &.quotation--left.quotation--top {
      .quotation__container {
        background-size: auto;
        transform: translateX(-1px);
        width: calc(100% + 1px);
      }
    }

    &.quotation--white {
      .quotation__container {
        background-image: $black-gradient-img;
      }

      .quotation__name,
      .quotation__info,
      .quotation__text {
        color: var(--skin-color-white, $ui-white);
      }
    }
  }
}
